const fonts = {
	light: 'AllianzNeo-Light',
	regular: 'AllianzNeo-Regular',
	semiBold: 'AllianzNeo-SemiBold',
	bold: 'AllianzNeo-Bold',
};

export default fonts;
